import { render, staticRenderFns } from "./dropMenu.vue?vue&type=template&id=60d58848&scoped=true&"
import script from "./dropMenu.vue?vue&type=script&lang=js&"
export * from "./dropMenu.vue?vue&type=script&lang=js&"
import style0 from "./dropMenu.vue?vue&type=style&index=0&id=60d58848&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d58848",
  null
  
)

export default component.exports